import _classCallCheck from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import { reduxForm } from '../../libs/reduxForm';
import { Loader } from '../../components';
import { wizardFormSections } from '../../constants';
import { fileTypes } from './_constants/files';
import PropTypes from 'prop-types';
import CompanyStep from './steps/CompanyStep';
import OperationsStep from './steps/OperationsStep';
import './DunsForm.css';

var DunsNumberForm =
/*#__PURE__*/
function (_Component) {
  _inherits(DunsNumberForm, _Component);

  function DunsNumberForm() {
    _classCallCheck(this, DunsNumberForm);

    return _possibleConstructorReturn(this, _getPrototypeOf(DunsNumberForm).apply(this, arguments));
  }

  _createClass(DunsNumberForm, [{
    key: "renderFooter",
    value: function renderFooter() {
      var _this$props = this.props,
          formStep = _this$props.formStep,
          selectedReasonOfRequest = _this$props.selectedReasonOfRequest,
          selectedCialCountry = _this$props.selectedCialCountry,
          formHasErrors = _this$props.formHasErrors,
          handleClickBack = _this$props.handleClickBack,
          saveInProgress = _this$props.saveInProgress,
          selectedAcceptLegal = _this$props.selectedAcceptLegal,
          fileMap = _this$props.fileMap;
      var dissalowSubmitIfNoFile = formStep === wizardFormSections.OPERATIONS && !fileMap[fileTypes.CONSTITUTIVE_ACT_COMPANY] && !fileMap[fileTypes.TAX_REGISTRATION_FORM];
      var dissalowFinalSubmit = formStep === wizardFormSections.OPERATIONS && !selectedAcceptLegal; // Don't allow user to continue if we have redirect information or if non cial country is chosen

      if (selectedReasonOfRequest && selectedReasonOfRequest.redirect || !selectedCialCountry) {
        return;
      }

      return React.createElement('div', {
        className: 'GetDunsNumberForm-footer'
      }, React.createElement('button', {
        type: 'button',
        className: 'Btn-outline Btn-outline-primary mtop-30',
        onClick: handleClickBack
      }, 'Back'), " ", React.createElement('button', {
        type: 'submit',
        className: 'Btn-default Btn-default-primary mtop-30',
        disabled: formHasErrors || saveInProgress || dissalowFinalSubmit || dissalowSubmitIfNoFile
      }, formStep === wizardFormSections.COMPANY ? 'Continue' : 'Submit'), React.createElement('p', {
        className: 'mtop-30'
      }, '* indicates mandatory fields '));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          user = _this$props2.user,
          submitting = _this$props2.submitting,
          handleSubmit = _this$props2.handleSubmit,
          formStep = _this$props2.formStep,
          metadata = _this$props2.metadata,
          selectedCountryRegionName = _this$props2.selectedCountryRegionName,
          selectedReasonOfRequest = _this$props2.selectedReasonOfRequest,
          selectedCialCountry = _this$props2.selectedCialCountry,
          selectedLegalStructure = _this$props2.selectedLegalStructure,
          shareholders = _this$props2.shareholders,
          onFileUpload = _this$props2.onFileUpload,
          onFileDelete = _this$props2.onFileDelete,
          isUserLegalRepresentative = _this$props2.isUserLegalRepresentative,
          fileMap = _this$props2.fileMap,
          fileState = _this$props2.fileState;

      if (submitting) {
        return React.createElement(Loader, {
          loading: true
        });
      }

      return React.createElement('form', {
        className: 'GetDunsNumberForm',
        onSubmit: handleSubmit
      }, formStep === wizardFormSections.COMPANY && React.createElement(CompanyStep, {
        selectedCountryRegionName: selectedCountryRegionName,
        selectedReasonOfRequest: selectedReasonOfRequest,
        selectedCialCountry: selectedCialCountry,
        metadata: metadata,
        user: user
      }), formStep === wizardFormSections.OPERATIONS && React.createElement(OperationsStep, {
        onFileUpload: onFileUpload,
        onFileDelete: onFileDelete,
        metadata: metadata,
        selectedCountryRegionName: selectedCountryRegionName,
        selectedLegalStructure: selectedLegalStructure,
        shareholders: shareholders,
        isUserLegalRepresentative: isUserLegalRepresentative,
        user: user,
        fileMap: fileMap,
        fileState: fileState
      }), this.renderFooter());
    }
  }]);

  return DunsNumberForm;
}(Component);

DunsNumberForm.propTypes = {
  initialValues: PropTypes.object,
  user: PropTypes.shape({
    companies: PropTypes.array,
    info: PropTypes.object.isRequired,
    preferences: PropTypes.object.isRequired,
    pulse: PropTypes.object.isRequired,
    registration: PropTypes.object.isRequired,
    security: PropTypes.object.isRequired,
    subscription: PropTypes.string
  }),
  onSubmit: PropTypes.func.isRequired,
  onValuesChange: PropTypes.func.isRequired,
  onFileUpload: PropTypes.func.isRequired,
  onFileDelete: PropTypes.func.isRequired,
  formStep: PropTypes.string.isRequired,
  fileMap: PropTypes.object.isRequired,
  fileState: PropTypes.object.isRequired,
  metadata: PropTypes.shape({
    isDunsForArgentinaArea: PropTypes.bool,
    isDunsForBrazil: PropTypes.bool,
    isDunsForCCS: PropTypes.bool,
    isDunsForMexico: PropTypes.bool,
    isDunsForPeruArea: PropTypes.bool
  }).isRequired,
  selectedCountryRegionName: PropTypes.string.isRequired,
  selectedReasonOfRequest: PropTypes.object,
  selectedCialCountry: PropTypes.bool.isRequired,
  selectedLegalStructure: PropTypes.string,
  selectedAcceptLegal: PropTypes.bool,
  formHasErrors: PropTypes.bool.isRequired,
  handleClickBack: PropTypes.func.isRequired,
  saveInProgress: PropTypes.bool.isRequired,
  isUserLegalRepresentative: PropTypes.string
};
var ReduxDunsNumberForm = reduxForm({
  form: 'dunsRequest',
  onChange: function onChange(values, _, props, previousValues) {
    return props.onValuesChange(values, previousValues);
  }
})(DunsNumberForm);
export default ReduxDunsNumberForm;